import { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import axios from 'axios';
import Widget_builder_container from './redux-container/widget_builder_container';
import { wdKit_Form_data, Get_user_info_data, get_user_login } from '../helper/helper-function';

const Loader = (props) => {

    const [data, setdata] = useState(false);
    const [state, setstate] = useState("");
    const [userData, setUserData] = useState("loading");

    var img_path = wdkitData.WDKIT_URL;

    const widget_name = useParams();
    const navigation = useNavigate();

    useEffect(() => {
        let login_data = get_user_login();
        if (!login_data) {
            navigation("/login")
        }

        let html = document.querySelectorAll('.notice');
        Object.values(html).map((tag) => {
            tag.style.display = 'none';
        })
    }, [])

    useEffect(() => {
        if (props.wdkit_meta) {
            setUserData(props.wdkit_meta);
        }
    }, [props.wdkit_meta]);

    const generateUniqueID = () => {
        const now = new Date();
        const uniqueID = `${now.getFullYear()}${now.getMonth()}${now.getDate()}${now.getHours()}${now.getMinutes()}${now.getSeconds()}`;
        const hashedID = parseInt(uniqueID, 10) % 10000;
        return String(hashedID).padStart(4, '0');
    }

    useEffect(() => {
        if (userData.success) {
            const UpdateList = async () => {
                let final_array = [];
                var countload = 0;

                let form_arr = { 'type': 'wkit_get_widget_list' }
                let plugin_data = await wdKit_Form_data(form_arr)
                    .then(response => {
                        const data = response;
                        return data;
                    })

                let server_data = userData?.widgettemplate;
                let widget_limit = userData?.credits?.limit_widget !== undefined ? userData?.credits?.limit_widget : 50;

                if (server_data?.length > 0) {
                    await plugin_data.map((data) => {
                        let index = server_data.findIndex((id) => id.w_unique == data.widgetdata.widget_id);
                        if (index <= -1 && ( widget_limit == -1 || final_array.length < widget_limit ) ) {

                            let name = data.widgetdata.name + "_" + data.widgetdata.widget_id;
                                final_array.push(name);
                        }
                    })

                    await server_data.map((data) => {
                        let index = plugin_data.findIndex((id) => id.widgetdata.widget_id == data.w_unique);
                        if (index >= -1 && ( widget_limit == -1 || final_array.length < widget_limit ) ) {
                            let w_name = plugin_data[index]?.widgetdata?.name;
                            let w_id = plugin_data[index]?.widgetdata?.widget_id;

                            let name = w_name + "_" + w_id;
                                final_array.push(name);
                        }
                    })
                } else {
                    await plugin_data.map((data) => {
                        if ( widget_limit == -1 || final_array.length < widget_limit ) {
                            let name = data.widgetdata.name + "_" + data.widgetdata.widget_id;
                                final_array.push(name);
                        }
                    })
                }

                const Get_data = async (valid_data) => {

                    let CharName = (widget_name && widget_name.id) ? widget_name.id : "";

                    let file = CharName ? CharName.replaceAll(" ", "_") : "";
                    let folder = CharName ? CharName.replaceAll(" ", "-") : "";

                    if (valid_data.includes(CharName)) {
                        var array_data = [];
                        var widgets = [];

                        let form_arr = { 'type': 'wkit_get_widget_list' }
                        await wdKit_Form_data(form_arr)
                            .then((response) => {
                                let data = [];
                                data = response;
                                data.map((widget) => {
                                    widgets.push(widget.widgetdata)
                                })
                            })

                        if ( widgets ) {
                            let count = widgets.length;
                            widgets.map(async (data) => {

                                if (data.name + "_" + data.widget_id == CharName) {

                                    let Json_URL = `${wdkitData.WDKIT_SERVER_PATH}/${data.type}/${folder}/${file}.json?v=${generateUniqueID()}`;

                                    await fetch(Json_URL)
                                        .then((response) => response.json())
                                        .then((json) => { array_data.push(json) })

                                    let old_html = [...props.Editor_code];
                                    old_html[0] = array_data[0].Editor_data

                                    props.addToEditor_code(old_html)
                                    props.addToCarthandler(array_data[0].section_data)
                                    props.addTowidgethandler(array_data[0].widget_data.widgetdata)
                                    props.addTolinkhandler(array_data[0].Editor_Link.links)

                                    setstate({
                                        "Editor_code": [array_data[0].Editor_data],
                                        "carddata": array_data[0].section_data,
                                        "widgetdata": array_data[0].widget_data.widgetdata,
                                        "links": array_data[0].Editor_Link.links,
                                    })
                                } else {
                                    count = count - 1
                                }
                            });

                            if ( count <= 0 ) {
                                if ( countload < 5 ) {
                                    countload = countload + 1;

                                    Get_data();
                                } else {
                                    // setTimeout(() => {
                                    //     navigation('/widget-listing')
                                    // }, 5000);
                                }
                            }
                        }
                    } else {
                        // setTimeout(() => {
                        //     navigation('/widget-listing')
                        // }, 5000);
                    }
                }
                Get_data(final_array);
            }
            UpdateList();
        }
    }, [userData?.userinfo])

    useEffect(() => {
        setTimeout(() => {
            if (props &&
                props.Editor_code &&
                props.Editor_data &&
                props.cardData &&
                props.widgetdata &&
                state &&
                state.Editor_code &&
                state.carddata &&
                state.widgetdata &&
                state.links) {
                if (JSON.stringify(props.Editor_code) == JSON.stringify(state.Editor_code) &&
                    JSON.stringify(props.Editor_data) == JSON.stringify(state.links) &&
                    JSON.stringify(props.cardData) == JSON.stringify(state.carddata) &&
                    JSON.stringify(props.widgetdata) == JSON.stringify(state.widgetdata)) {
                    setdata(true)
                }
            }
        }, 800)
    });

    return (
        <>
            {data == true ? 
                    <Widget_builder_container /> 
                : 
                <div className="wb-loader" style={{ display: 'flex' }} >
                    <img style={{ width: '150px', height: '150px', marginLeft: '-160px' }} src={img_path + "assets/images/jpg/wdkit_loader.gif"} />
                </div>
            }
            
        </>
    );
}

export default Loader;